export default {
  name: 'wapp',
  props: {
    msg: String
  }
}